import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Redirect } from 'react-router-dom';
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import InlineEditDate from '../common/inline-edit/date.component.jsx';
import StandardList from '../common/listing/list.component.jsx';
import Pagination from '../common/listing/pagination.component.jsx';
import NewAccountStatementModal from './accountstatementmodal.component.jsx';

class AccountStatementListByContact extends Component {

    constructor(props, context) {
        super(props, context)
        const contactId = this.props.contactId || ''
        this.state = {
            contactId: contactId,
            headers: [],
            rows: [],
            redirect: '',
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
        }
        this.createAccountStatement = this.createAccountStatement.bind(this)
        this.refreshInvoiceList = this.refreshInvoiceList.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.stopLoading = this.stopLoading.bind(this)
    }

    componentDidMount() {
        if (this.state.contactId) {
            this.refreshInvoiceList()
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            contactId: nextProps.contactId
        }, () => {
            this.refreshInvoiceList()
        })
    }

    stopLoading() {
        this.setState({
            moreLoading: false,
        })
    }

    printPdf(statementId) {
        return function (e) {
            AppContext.getApiClient().get(`/account-statements/${statementId}`).then(res => {
                GlobalHelper.redirectToPrintPdf(res.attributes.printUrl)
            })
        }.bind(this)
    }

    row(statement) {
        let label = <FormattedMessage
            id="customers.account_statement.list.statement_of_label"
            defaultMessage="Statement of {date}"
            values={{
                date: <InlineEditDate
                    popupClassName={'top-inherit'}
                    value={statement.date}
                    endPoint={'/account-statements/' + statement.id}
                    field={'date'}
                    editable={true}
                />
            }}
        />
        return [
            <span>{statement.identifier} - {label}</span>,
            <div className={'w-100 d-flex justify-content-end'}>
                <button type='button' className='btn btn-sm btn-outline-primary mr-2' onClick={this.printPdf(statement.id)}>
                    <Icon value={'print'} className={'mr-1'} />
                    <FormattedMessage
                        id="customer.account_statement.print_button"
                        defaultMessage="Print"
                    />
                </button>
                <Link to={'/proposals/' + statement.proposalHash + '/preview'}
                    className={'btn btn-sm btn-outline-primary mr-2'}
                >
                    <Icon value={'envelope'} className={'mr-1'} />
                    <FormattedMessage
                        id="customer.account_statement.edit_and_send_button"
                        defaultMessage="Edit and send again"
                    />
                </Link>
                <a className={'btn btn-sm btn-outline-primary'} href={'/p/proposals/' + statement.proposalHash} target={'_blank'}>
                    <Icon value={'external-link-alt'} className={'mr-1'} />
                    <FormattedMessage
                        id="customer.account_statement.open_btn"
                        defaultMessage="Open"
                    />
                </a>
            </div>,
        ]
    }

    loadInvoicesByContactId(contactId) {
        let postData = {
            keywords: '*',
            objects: ['account-statements'],
            fields: ['proposalHash', 'contactId'],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                contactId: contactId,
            },
            lightResult: true,
        }

        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            this.setState({
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.refreshInvoiceList()
        })
    }

    refreshInvoiceList() {
        this.loadInvoicesByContactId(this.state.contactId)
    }

    createAccountStatement(event) {
        event.preventDefault()
        this.setState({
            redirect: <NewAccountStatementModal
                contactId={this.state.contactId}
                onClose={res => {
                    if (res) {
                        this.setState({
                            redirect: <Redirect to={'/proposals/' + res.attributes.hash + '/preview'} />
                        })
                    } else {
                        this.setState({
                            redirect: ''
                        })
                    }
                }}
            />
        })
    }

    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                {this.state.redirect}
                <StandardList
                    tableContainerStyle={{
                        overflowX: 'initial'
                    }}
                    smallLine={true}
                    className="row pt-0"
                    headers={['', '']}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        <div>
                            <button className="btn btn-primary btn-sm" onClick={this.createAccountStatement}>
                                <Icon value={'plus-circle'} className={'mr-1'} />
                                <FormattedMessage
                                    id="customers.account_statement.list.create_account_statement_btn"
                                    defaultMessage="Create account statement"
                                />
                            </button>
                        </div>
                    </div>}
                />
            </div>

        );
    }
}

export default AccountStatementListByContact





// WEBPACK FOOTER //
// ./src/customer/accountstatementlist.component.jsx